import { DataService } from 'src/app/services/data.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-step-c',
  templateUrl: './step-c.component.html',
  styleUrls: ['./step-c.component.scss'],
})
export class StepCComponent {
  get dataService(): DataService {
    return this._dataService;
  }

  constructor(private _dataService: DataService) {}
}
